import {
  asosGlobalNamespace,
  sdkGlobalNamespace,
  audiencesSdkGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";

export const setupAudienceSegmentsEvent = () => {
  window[asosGlobalNamespace].eventBus.addListener(
    "audience-sdk-ready",
    async () => {
      const {
        customer: { isAuthenticated }
      } = await sdkInstanceProvider("identity");
      let segments;

      if (await isAuthenticated()) {
        try {
          segments =
            (await window[asosGlobalNamespace][sdkGlobalNamespace][
              audiencesSdkGlobalNamespace
            ].getSegments()) || [];

          segments = segments.map(({ segmentId }) => segmentId);
        } catch (error) {
          noticeError(error);
        }
      }

      window[asosGlobalNamespace][siteChromeGlobalNamespace].pushToDataLayer({
        customerSegmentsData: {
          segments: segments || []
        }
      });
    }
  );
};
